interface ClaimableAsset {
  assetType: string;
  amountOfAssets: number;
  availableToClaim: number;
}

const doodAssetOrderMap: { [key: string]: number } = {
  SpaceMiles: 1,
  Doodles: 2,
  SpaceDoodles: 3,
  Dooplicator: 4,
  GenesisBox: 5,
  iconic: 6,
  grail: 7,
  exclusive: 8,
  essential: 9,
  Posters: 10,
  BetaPass: 11,
  DoodlesCertifiedViral: 12,
  Pass: 13,
};

/**
 * Sorts an array of claimable assets based on a predefined order.
 * @function sortClaimableAssets
 * @param {ClaimableAsset[]} availableToClaimPerAssetType - The array of claimable assets to sort.
 * @returns {ClaimableAsset[]} The sorted array of claimable assets.
 */
export const sortClaimableAssets = (
  availableToClaimPerAssetType: ClaimableAsset[],
): ClaimableAsset[] => {
  return availableToClaimPerAssetType.sort(
    (a, b) =>
      (doodAssetOrderMap[a.assetType] ?? 0) -
      (doodAssetOrderMap[b.assetType] ?? 0),
  );
};
